import React, { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import IconButton from "@mui/material/IconButton";
import InputAdornment from "@mui/material/InputAdornment";
import LockIcon from "@mui/icons-material/Lock";
import LockOpenIcon from "@mui/icons-material/LockOpen";
import TextField from "@mui/material/TextField";

import { GET_SHIPMENT_QUERY } from "../../../constants/graphql/queries";
import { UPDATE_SHIPMENT_ITEMS_MUTATION } from "../../../constants/graphql/mutations";
import useMutation from "../../../hooks/useMutation";
import useQueryParams from "../../../hooks/useQueryParams";

export default function ShipmentItemQuantityField({
  shipmentItemQuantity,
  availableQuantity,
  onShipmentItemQuantityUpdate,
}) {
  const params = useQueryParams();
  const shipmentItemId = params.get("shipmentItemId");
  const shipmentId = params.get("id");
  const shipmentCode = params.get("shipmentId");
  const [locked, setLocked] = useState(true);
  const [quantity, setQuantity] = useState(shipmentItemQuantity || 0);
  const [updateShipmentItem, { loading }] = useMutation(UPDATE_SHIPMENT_ITEMS_MUTATION);

  useEffect(() => {
    if (locked) setQuantity(shipmentItemQuantity || 0);
  }, [locked, shipmentItemQuantity]);

  const quantityMatchesAvailable =
    shipmentItemQuantity !== undefined &&
    shipmentItemQuantity !== null &&
    availableQuantity !== undefined &&
    availableQuantity !== null &&
    Number(shipmentItemQuantity) === Number(availableQuantity);

  if (!shipmentItemId || quantityMatchesAvailable) return null;

  const saveQuantity = async () => {
    const updatedQuantity = Number(quantity) || 0;
    updateShipmentItem({
      variables: { id: shipmentItemId, quantity: updatedQuantity },
      refetchQueries: shipmentId ? [{ query: GET_SHIPMENT_QUERY, variables: { id: shipmentId } }] : [],
      onSuccess: () => {
        onShipmentItemQuantityUpdate?.(updatedQuantity);
        setLocked(true);
      },
    });
  };

  return (
    <Box display="flex" justifyContent="flex-end" alignItems="center" gap={1}>
      <TextField
        size="small"
        type="number"
        label={`${shipmentCode} Quantity`}
        value={quantity}
        onChange={event => setQuantity(event.target.value)}
        disabled={locked}
        inputProps={{ min: 0 }}
        sx={{ width: 195 }}
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              <IconButton
                aria-label={locked ? "Unlock shipment item quantity" : "Lock shipment item quantity"}
                edge="end"
                onClick={() => setLocked(value => !value)}
              >
                {locked ? <LockIcon /> : <LockOpenIcon />}
              </IconButton>
            </InputAdornment>
          ),
        }}
      />
      {!locked && (
        <Button disabled={loading} onClick={saveQuantity} variant="outlined" size="small">
          Update
        </Button>
      )}
    </Box>
  );
}
